(() => {
  const root = document.querySelector('[data-terror-head]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const canvas = root.querySelector('canvas');
  const stage = root.querySelector('.terror-head-stage');
  const fallback = root.querySelector('[data-head-fallback]');
  const gl = canvas.getContext('webgl', { alpha: true, antialias: true });
  if (!gl) return;
  const compile = (type, source) => {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, source); gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(shader));
    return shader;
  };
  try {
    const program = gl.createProgram();
    gl.attachShader(program, compile(gl.VERTEX_SHADER, `
      attribute vec3 position; attribute vec3 normal;
      uniform vec2 rotation; uniform float aspect; uniform float scale; uniform float lunge; uniform vec2 offset; uniform float roll;
      varying vec3 local; varying vec3 surface; varying vec3 facing;
      void main() {
        float cy=cos(rotation.x), sy=sin(rotation.x), cx=cos(rotation.y), sx=sin(rotation.y);
        mat3 ry=mat3(cy,0.,-sy,0.,1.,0.,sy,0.,cy);
        mat3 rx=mat3(1.,0.,0.,0.,cx,sx,0.,-sx,cx);
        mat3 turn=rx*ry;
        vec3 p=turn*position;
        p.xy=mat2(cos(roll),sin(roll),-sin(roll),cos(roll))*p.xy+offset;
        local=position; surface=normal; facing=turn*normal;
        float depth=4.6-lunge-p.z;
        gl_Position=vec4(p.x*scale/aspect, p.y*scale, -p.z*.3, depth);
      }
    `));
    gl.attachShader(program, compile(gl.FRAGMENT_SHADER, `
      precision mediump float;
      uniform sampler2D sketch; uniform sampler2D pupil; uniform sampler2D eyeMask;
      uniform float art; uniform vec2 gaze; uniform float pupilVisible;
      varying vec3 local; varying vec3 surface; varying vec3 facing;
      float pupilAt(vec2 uv,vec2 center){
        vec2 p=(uv-center-gaze)/vec2(.155,.235)+.5;
        if(p.x<0.||p.x>1.||p.y<0.||p.y>1.)return 0.;
        return texture2D(pupil,p).a;
      }
      void main() {
        vec2 uv=vec2(local.x/2.45+.5,.5-local.y/2.30);
        vec4 face=texture2D(sketch,uv);
        float mask=smoothstep(.04,.35,normalize(surface).z)*art;
        float eye=texture2D(eyeMask,uv).r;
        float iris=max(pupilAt(uv,vec2(.32,.64)),pupilAt(uv,vec2(.665,.638)) )*eye*pupilVisible;
        vec3 base=mix(vec3(.96,.96,.95),vec3(.015),iris*mask);
        base=mix(base,face.rgb,face.a*mask);
        float light=.62+.38*max(dot(normalize(facing),normalize(vec3(-1.,1.3,2.5))),0.);
        gl_FragColor=vec4(base*light,1.);
      }
    `));
    gl.linkProgram(program);
    if (!gl.getProgramParameter(program,gl.LINK_STATUS)) throw new Error(gl.getProgramInfoLog(program));
    gl.useProgram(program); gl.enable(gl.DEPTH_TEST);
    const loc = name => gl.getUniformLocation(program,name);
    const makeMesh = (positions,normals,indices) => {
      const p=gl.createBuffer(),n=gl.createBuffer(),i=gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER,p);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array(positions),gl.STATIC_DRAW);
      gl.bindBuffer(gl.ARRAY_BUFFER,n);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array(normals),gl.STATIC_DRAW);
      gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER,i);gl.bufferData(gl.ELEMENT_ARRAY_BUFFER,new Uint16Array(indices),gl.STATIC_DRAW);
      return {p,n,i,count:indices.length};
    };
    const p=[],n=[],indices=[],rings=100,sides=128;
    const profile=[[-1,0],[-.985,.35],[-.95,.64],[-.88,.77],[-.76,.82],[-.63,.835],[-.54,.815],[-.4,.87],[-.15,.97],[.1,1.02],[.35,.985],[.6,.88],[.8,.68],[.94,.39],[1,0]];
    const radiusAt=y=>{
      let i=0;while(i<profile.length-2&&y>profile[i+1][0])i++;
      const p=profile[i],q=profile[i+1],prev=profile[Math.max(0,i-1)],next=profile[Math.min(profile.length-1,i+2)];
      const h=q[0]-p[0],t=Math.max(0,Math.min(1,(y-p[0])/h));
      const m0=(q[1]-prev[1])/(q[0]-prev[0]),m1=(next[1]-p[1])/(next[0]-p[0]);
      return Math.max(0,(2*t*t*t-3*t*t+1)*p[1]+(t*t*t-2*t*t+t)*h*m0+(-2*t*t*t+3*t*t)*q[1]+(t*t*t-t*t)*h*m1);
    };
    const shape=(theta,phi)=>{
      const y=Math.cos(theta),r=radiusAt(y),front=Math.sin(phi);
      const z=Math.sqrt(Math.max(0,1-y*y))*1.05*front;
      const chin=.025*Math.exp(-Math.pow((y+.77)/.23,2))*Math.max(0,front);
      return [r*Math.cos(phi),y*1.04,z+chin];
    };
    const normalAt=(fn,u,v)=>{
      const eps=.0002,a=fn(u+eps,v),b=fn(u-eps,v),c=fn(u,v+eps),d=fn(u,v-eps);
      const du=a.map((x,i)=>x-b[i]),dv=c.map((x,i)=>x-d[i]);
      const cross=[du[1]*dv[2]-du[2]*dv[1],du[2]*dv[0]-du[0]*dv[2],du[0]*dv[1]-du[1]*dv[0]];
      const len=Math.hypot(...cross)||1;return cross.map(x=>-x/len);
    };
    for(let y=0;y<=rings;y++) {
      const theta=Math.max(.0001,Math.min(Math.PI-.0001,y/rings*Math.PI));
      for(let x=0;x<=sides;x++) {
        const phi=x/sides*Math.PI*2;
        p.push(...shape(theta,phi));n.push(...normalAt(shape,theta,phi));
      }
    }
    for(let y=0;y<rings;y++) for(let x=0;x<sides;x++) {
      const a=y*(sides+1)+x,b=a+sides+1;indices.push(a,b,a+1,b,b+1,a+1);
    }
    const head=makeMesh(p,n,indices);
    const earP=[],earN=[],earI=[];
    const outline=[[1.185,.29],[1.23,.06],[1.21,-.15],[1.12,-.37],[.91,-.57],[.87,-.46],[.955,-.12],[.975,.12]];
    const boundary=angle=>{
      const u=(angle/(Math.PI*2)%1+1)%1*outline.length,i=Math.floor(u),t=u-i,N=outline.length;
      const a=outline[(i+N-1)%N],b=outline[i%N],c=outline[(i+1)%N],d=outline[(i+2)%N];
      return [0,1].map(k=>.5*((2*b[k])+(-a[k]+c[k])*t+(2*a[k]-5*b[k]+4*c[k]-d[k])*t*t+(-a[k]+3*b[k]-3*c[k]+d[k])*t*t*t));
    };
    const ear=(r,angle,side)=>{
      const edge=boundary(angle),cx=1.025,cy=-.15;
      const x=cx+(edge[0]-cx)*r,y=cy+(edge[1]-cy)*r;
      const rim=.018*Math.exp(-Math.pow((r-.78)/.25,2));
      const fold=.009*Math.exp(-Math.pow((r-.4)/.24,2))*(.6+.4*Math.sin(angle));
      const z=.035+.15*Math.pow(Math.max(0,1-r*r),.8)+rim+fold;
      return [side*x,y,z];
    };
    const er=55,es=96;
    for(const side of [-1,1]) {
      const offset=earP.length/3,fn=(u,v)=>ear(u,v,side);
      for(let y=0;y<=er;y++)for(let x=0;x<=es;x++){
        const r=Math.max(.0001,y/er),angle=x/es*Math.PI*2;
        earP.push(...fn(r,angle));let nn=normalAt(fn,r,angle);
        if(nn[2]<0)nn=nn.map(v=>-v);earN.push(...nn);
      }
      for(let y=0;y<er;y++)for(let x=0;x<es;x++){
        const a=offset+y*(es+1)+x,b=a+es+1;earI.push(a,b,a+1,b,b+1,a+1);
      }
    }
    const ears=makeMesh(earP,earN,earI);
    const decode=(value,Type)=>{
      const bytes=Uint8Array.from(atob(value),c=>c.charCodeAt(0));return new Type(bytes.buffer);
    };
    const sculpt=(window.BabyTerrorsSculpt||[]).map(part=>makeMesh(
      Float32Array.from(decode(part.p,Int16Array),v=>v/16000),
      Float32Array.from(decode(part.n,Int8Array),v=>v/127),
      decode(part.i,Uint16Array)
    ));
    const loadImage=url=>new Promise((resolve,reject)=>{const im=new Image();im.crossOrigin='anonymous';im.onload=()=>resolve(im);im.onerror=reject;im.src=url;});
    const bindTexture=(source,unit,name)=>{
      const texture=gl.createTexture();gl.activeTexture(gl.TEXTURE0+unit);gl.bindTexture(gl.TEXTURE_2D,texture);
      gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
      gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,source);gl.uniform1i(loc(name),unit);return texture;
    };
    const makeEyeMask=image=>{
      const size=1024,c=document.createElement('canvas');c.width=c.height=size;
      const ctx=c.getContext('2d',{willReadFrequently:true});ctx.drawImage(image,0,0,size,size);
      const pixels=ctx.getImageData(0,0,size,size).data,blocked=new Uint8Array(size*size);
      for(let y=3;y<size-3;y++)for(let x=3;x<size-3;x++){
        const i=y*size+x;
        blocked[i]=Math.max(pixels[i*4+3],pixels[(i-3)*4+3],pixels[(i+3)*4+3],pixels[(i-size*3)*4+3],pixels[(i+size*3)*4+3])>210?1:0;
      }
      const output=ctx.createImageData(size,size),seen=new Uint8Array(size*size),queue=new Int32Array(size*size);
      for(const seed of [650*size+300,650*size+650]){
        let head=0,tail=0;queue[tail++]=seed;seen[seed]=1;
        while(head<tail){
          const i=queue[head++];output.data[i*4]=output.data[i*4+1]=output.data[i*4+2]=255;output.data[i*4+3]=255;
          for(const j of [i-1,i+1,i-size,i+size])if(j>=0&&j<size*size&&!seen[j]&&!blocked[j]){seen[j]=1;queue[tail++]=j;}
        }
      }
      const expanded=ctx.createImageData(size,size);
      const offsets=[];
      for(let dy=-3;dy<=3;dy++)for(let dx=-3;dx<=3;dx++){
        const coverage=Math.max(0,Math.min(1,3.5-Math.hypot(dx,dy)));
        if(coverage>0)offsets.push([dy*size+dx,coverage]);
      }
      for(let y=3;y<size-3;y++)for(let x=3;x<size-3;x++){
        const i=y*size+x;
        let coverage=0;
        for(const [offset,weight] of offsets)if(seen[i+offset])coverage=Math.max(coverage,weight);
        if(coverage){expanded.data[i*4]=expanded.data[i*4+1]=expanded.data[i*4+2]=Math.round(255*coverage);expanded.data[i*4+3]=255;}
      }
      ctx.putImageData(expanded,0,0);return c;
    };
    const textures={};
    const moods=window.BabyTerrorsCreateMoods(performance.now());
    let currentMood={mode:'normal',elapsed:0,progress:0};
    const available=mode=>!!textures[mode];
    let idleTimer;
    const wake=()=>{const now=performance.now();moods.wake(now,available);lastInteraction=now;clearTimeout(idleTimer);idleTimer=setTimeout(schedule,4020);schedule();};
    let yaw=0,pitch=0,targetYaw=0,targetPitch=0,drag=false,lastX=0,lastY=0,loaded=false,showArt=true,frame=0;
    let gazeX=0,gazeY=0,targetGazeX=0,targetGazeY=0;
    let lastInteraction=performance.now(),lastFrame=0,disposed=false;
    const drawMesh=(mesh,art)=>{
      for(const [name,buffer] of [['position',mesh.p],['normal',mesh.n]]) {
        const a=gl.getAttribLocation(program,name);gl.bindBuffer(gl.ARRAY_BUFFER,buffer);gl.enableVertexAttribArray(a);gl.vertexAttribPointer(a,3,gl.FLOAT,false,0,0);
      }
      gl.uniform1f(loc('art'),art);gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER,mesh.i);gl.drawElements(gl.TRIANGLES,mesh.count,gl.UNSIGNED_SHORT,0);
    };
    const draw=()=>{
      if(!loaded)return;
      const rect=stage.getBoundingClientRect(),dpr=Math.min(devicePixelRatio||1,2);
      const w=Math.round(rect.width*dpr),h=Math.round(rect.height*dpr);
      if(canvas.width!==w||canvas.height!==h){canvas.width=w;canvas.height=h;}
      gl.viewport(0,0,canvas.width,canvas.height);gl.clearColor(0,0,0,0);gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);
      const {mode,elapsed,progress}=currentMood;
      const envelope=Math.min(1,elapsed/180)*Math.min(1,(1800-elapsed)/240);
      const shake=mode==='rage'&&!reduced?Math.max(0,envelope):0;
      const extraYaw=shake*(Math.sin(elapsed*.11)*.018+Math.sin(elapsed*.173)*.006);
      const extraPitch=shake*Math.sin(elapsed*.137)*.010;
      gl.uniform2f(loc('rotation'),yaw+extraYaw,pitch+extraPitch);
      gl.uniform2f(loc('offset'),shake*Math.sin(elapsed*.151)*.006,shake*Math.cos(elapsed*.127)*.004);
      gl.uniform1f(loc('roll'),mode==='kiss'&&!reduced?Math.sin(progress*Math.PI)*.055:0);
      gl.uniform1f(loc('aspect'),rect.width/rect.height);gl.uniform1f(loc('scale'),Math.min(4.0,2.9*rect.width/rect.height));
      const lunge=mode==='bite'?(progress<.20?Math.sin(progress/.20*Math.PI/2):progress<.65?1:Math.pow(1-(progress-.65)/.35,2)):0;
      gl.uniform1f(loc('lunge'),reduced?0:lunge*.38);
      const texture=textures[mode==='bite'&&elapsed>=390?'normal':mode]||textures.normal;
      gl.activeTexture(gl.TEXTURE0);gl.bindTexture(gl.TEXTURE_2D,texture.face);
      gl.activeTexture(gl.TEXTURE2);gl.bindTexture(gl.TEXTURE_2D,texture.mask);
      gl.uniform1f(loc('pupilVisible'),['sleep','blink'].includes(mode)?0:1);
      if(mode==='blink'&&root.dataset.expression!=='blink')root.dataset.blinkCount=String(Number(root.dataset.blinkCount||0)+1);
      root.dataset.expression=mode;root.dataset.biting=String(mode==='bite');root.dataset.pupilsVisible=String(!['sleep','blink'].includes(mode));
      gl.uniform2f(loc('gaze'),gazeX,gazeY);
      if(sculpt.length){for(const mesh of sculpt)drawMesh(mesh,showArt?1:0);}else{drawMesh(ears,0);drawMesh(head,showArt?1:0);}
    };
    Promise.all([
      loadImage('https://cdn.shopify.com/s/files/1/1431/2946/files/baby-terrors-face-v2.png?v=1793087223'),
      loadImage('https://cdn.shopify.com/s/files/1/1431/2946/files/baby-terrors-pupil-v1.png?v=1793045098'),
      loadImage('https://cdn.shopify.com/s/files/1/1431/2946/files/baby-terrors-sleep.png?v=1793214312').catch(()=>null),
      loadImage('https://cdn.shopify.com/s/files/1/1431/2946/files/baby-terrors-rage.png?v=1793214326').catch(()=>null)
    ]).then(([face,pupil,sleep,rage])=>{
      textures.normal={face:bindTexture(face,0,'sketch'),mask:bindTexture(makeEyeMask(face),2,'eyeMask')};bindTexture(pupil,1,'pupil');
      if(sleep)textures.sleep={face:bindTexture(sleep,0,'sketch'),mask:textures.normal.mask};
      if(rage)textures.rage={face:bindTexture(rage,0,'sketch'),mask:bindTexture(makeEyeMask(rage),2,'eyeMask')};
      const expressionUrls={
        bite:'https://cdn.shopify.com/s/files/1/1431/2946/files/baby-terrors-bite-open.png?v=1793167406',
        kiss:'https://cdn.shopify.com/s/files/1/1431/2946/files/baby-terrors-kiss-v2.png?v=1793215088',
        blink:'https://cdn.shopify.com/s/files/1/1431/2946/files/baby-terrors-blink-v2.png?v=1793215081'
      };
      for(const [mode,url] of Object.entries(expressionUrls))loadImage(url).then(image=>{
        textures[mode]={face:bindTexture(image,0,'sketch'),mask:['sleep','blink'].includes(mode)?textures.normal.mask:bindTexture(makeEyeMask(image),2,'eyeMask')};
        root.dataset.expressionsReady=Object.keys(textures).join(',');schedule();
      }).catch(error=>console.error('Baby Terrors expression '+mode,error));
      moods.entrance(performance.now(),available);currentMood=moods.tick(performance.now(),available);if(currentMood.mode==='sleep')pitch=.13;
      setTimeout(()=>{if(!disposed){currentMood=moods.tick(performance.now(),available);schedule();}},520);
      idleTimer=setTimeout(schedule,4520);
      loaded=true;fallback.hidden=true;canvas.hidden=false;root.classList.add('is-loaded');draw();schedule();
    }).catch(error=>{console.error('Baby Terrors texture load',error);fallback.hidden=false;canvas.hidden=true;});
    const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
    const animate=now=>{
      frame=0;
      if(disposed||!loaded||document.hidden)return;
      const rect=stage.getBoundingClientRect(),visible=rect.bottom>0&&rect.top<innerHeight;
      if(now-lastFrame<(['bite','rage','kiss','blink'].includes(currentMood.mode)?16:32)){frame=requestAnimationFrame(animate);return;}
      currentMood=moods.tick(now,available);
      const dt=Math.min((now-lastFrame)/1000||.033,.1);lastFrame=now;
      if(visible){
        const idle=!reduced&&!drag&&now-lastInteraction>2600;
        const t=now/1000;
        const sleeping=currentMood.mode==='sleep';
        const hy=sleeping?Math.sin(t*.35)*.012:idle?Math.sin(t*.27)*.055:targetYaw;
        const hp=sleeping?.17+(reduced?0:Math.sin(t*.8)*.008):idle?Math.sin(t*.19+1.2)*.022:targetPitch;
        const gx=idle?Math.sin(t*.27+.4)*.018:targetGazeX;
        const gy=idle?Math.sin(t*.19+1.6)*.008:targetGazeY;
        const eyeSpeed=reduced?1:1-Math.exp(-15*dt),headSpeed=reduced?1:1-Math.exp(-(sleeping?.65:2)*dt);
        gazeX+=(gx-gazeX)*eyeSpeed;gazeY+=(gy-gazeY)*eyeSpeed;
        yaw+=(hy-yaw)*headSpeed;pitch+=(hp-pitch)*headSpeed;draw();
      }
      const moving=Math.abs(targetYaw-yaw)+Math.abs(targetPitch-pitch)+Math.abs(targetGazeX-gazeX)+Math.abs(targetGazeY-gazeY)>.0002;
      if(!reduced||moving||['bite','rage','kiss','blink'].includes(currentMood.mode))frame=requestAnimationFrame(animate);
    };
    const schedule=()=>{if(!frame)frame=requestAnimationFrame(animate);};
    const react=kind=>{if(!loaded)return;const now=performance.now();if(moods.react(kind,now,available)){lastInteraction=now;currentMood=moods.tick(now,available);schedule();}};
    canvas.addEventListener('dblclick',e=>{e.preventDefault();react('random');});
    let lastTap=0,tapX=0,tapY=0,downX=0,downY=0;
    canvas.addEventListener('pointerdown',e=>{wake();downX=e.clientX;downY=e.clientY;});
    canvas.addEventListener('pointerup',e=>{if(e.pointerType==='mouse'||Math.hypot(e.clientX-downX,e.clientY-downY)>15)return;const now=performance.now();if(now-lastTap<320&&Math.hypot(e.clientX-tapX,e.clientY-tapY)<35){react('random');lastTap=0;}else{lastTap=now;tapX=e.clientX;tapY=e.clientY;}});
    canvas.addEventListener('pointerdown',e=>{drag=true;lastX=e.clientX;lastY=e.clientY;canvas.setPointerCapture(e.pointerId);});
    let mouthEntered=false,earEntered=false;
    const project=(x,y,z,r)=>{const cy=Math.cos(yaw),sy=Math.sin(yaw),cx=Math.cos(pitch),sx=Math.sin(pitch);const xx=cy*x+sy*z,zz=-sy*x+cy*z,yy=cx*y-sx*zz,depth=4.6-(sx*y+cx*zz),unit=r.height*Math.min(4,2.9*r.width/r.height)/(2*depth);return{x:r.left+r.width/2+xx*unit,y:r.top+r.height/2-yy*unit,unit};};
    document.addEventListener('pointermove',e=>{
      wake();
      if(e.pointerType==='mouse'&&!drag){
        const r=stage.getBoundingClientRect();
        const near=(point,rx,ry)=>Math.pow((e.clientX-point.x)/(point.unit*rx),2)+Math.pow((e.clientY-point.y)/(point.unit*ry),2)<1;
        const mouth=near(project(-.06,-.67,1,r),.34,.20);
        const ears=near(project(-1.05,-.15,.2,r),.22,.30)||near(project(1.05,-.15,.2,r),.22,.30);
        if(ears&&!earEntered)react('kiss');else if(mouth&&!mouthEntered)react('mouth');
        mouthEntered=mouth;earEntered=ears;
      }
      const eyeRect=stage.getBoundingClientRect();
      targetGazeX=Math.max(-.085,Math.min(.085,(e.clientX-eyeRect.left-eyeRect.width/2)/Math.max(eyeRect.width/2,1)*.085));
      targetGazeY=Math.max(-.022,Math.min(.022,(e.clientY-eyeRect.top-eyeRect.height/2)/Math.max(eyeRect.height/2,1)*.022));
      if(drag){
        targetYaw=Math.max(-.65,Math.min(.65,targetYaw+(e.clientX-lastX)*.004));
        targetPitch=Math.max(-.25,Math.min(.25,targetPitch+(e.clientY-lastY)*.003));
        lastX=e.clientX;lastY=e.clientY;
      }else if(e.pointerType==='mouse'){
        const rect=stage.getBoundingClientRect();
        if(rect.bottom<0||rect.top>innerHeight)return;
        targetYaw=Math.max(-.18,Math.min(.18,(e.clientX-(rect.left+rect.width/2))/Math.max(rect.width/2,1)*.18));
        targetPitch=Math.max(-.09,Math.min(.09,(e.clientY-(rect.top+rect.height/2))/Math.max(rect.height/2,1)*.09));
      }else return;
      schedule();
    });
    const release=()=>{drag=false;};canvas.addEventListener('pointerup',release);canvas.addEventListener('pointercancel',release);
    canvas.addEventListener('keydown',e=>{
      wake();
      if(['Enter',' '].includes(e.key)){e.preventDefault();react('random');return;}
      if(!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home'].includes(e.key))return;
      e.preventDefault();
      if(e.key==='Home'){targetYaw=0;targetPitch=0;}else{
        targetYaw=Math.max(-.65,Math.min(.65,targetYaw+(e.key==='ArrowLeft'?-.08:e.key==='ArrowRight'?.08:0)));
        targetPitch=Math.max(-.25,Math.min(.25,targetPitch+(e.key==='ArrowUp'?-.06:e.key==='ArrowDown'?.06:0)));
      }schedule();
    });
    for(const event of ['keydown','pointerdown','scroll'])document.addEventListener(event,wake,{passive:true});
    const observer=new ResizeObserver(draw);observer.observe(stage);
    document.addEventListener('visibilitychange',()=>{if(!document.hidden)schedule();});
    canvas.addEventListener('webglcontextlost',e=>{e.preventDefault();loaded=false;canvas.hidden=true;fallback.hidden=false;});
    document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(root)){disposed=true;clearTimeout(idleTimer);observer.disconnect();cancelAnimationFrame(frame);}});
  } catch(error) {console.error('Baby Terrors render',error);canvas.hidden=true;fallback.hidden=false;}
})();
